import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { Supplier } from '../models/supplier';
import { TermsAndConditions } from '../models/terms-and-conditions';

export const CLEAR_SUPPLIER_CONDITIONS = 'CLEAR_SUPPLIER_CONDITIONS';
export const RECEIVE_SUPPLIER_CONDITIONS = 'RECEIVE_SUPPLIER_CONDITIONS';
export const RECEIVE_SUPPLIERS = 'RECEIVE_SUPPLIERS';
export const REQUEST_SUPPLIERS = 'REQUEST_SUPPLIERS';
export const REQUEST_SUPPLIERS_COMPLETE = 'REQUEST_SUPPLIERS_COMPLETE';
export const RESET_SUPPLIERS = 'RESET_SUPPLIERS';

export const resetSuppliers = () => {
    return {
        type: RESET_SUPPLIERS,
    };
};

const requestSuppliers = () => {
    return {
        type: REQUEST_SUPPLIERS,
    };
};

const requestSuppliersComplete = () => {
    return {
        type: REQUEST_SUPPLIERS_COMPLETE,
    };
};

const receiveSuppliers = (suppliers: PaginatedResponse<Supplier>, append: boolean) => {
    return {
        type: RECEIVE_SUPPLIERS,
        suppliers,
        append,
    };
};

const receiveSupplierConditions = (termsAndConditions: TermsAndConditions) => {
    return {
        type: RECEIVE_SUPPLIER_CONDITIONS,
        termsAndConditions,
    };
};

export const clearSupplierConditions = () => {
    return {
        type: CLEAR_SUPPLIER_CONDITIONS,
    };
};

export const fetchSupplierConditions = (supplierId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.accounts.getBonusConditions(supplierId);
        if (response.success) {
            dispatch(receiveSupplierConditions(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchSuppliers = (searchParams: URLSearchParams, append?: boolean) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestSuppliers());
        const response = await api.supplier.cget(searchParams);
        dispatch(requestSuppliersComplete());

        if (response.success) {
            dispatch(receiveSuppliers(response.result, !!append));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
